import {
  Parcel,
  EDB,
  Warehouse,
  Dockyard,
  DispositionType,
  ShippingRecord,
} from "$types";

export type PreparationOrderCode = `OP${number}`;

export enum PreparationOrderStatus {
  CREATED,
  IN_PROGRESS,
  PREPARED,
  TO_SHIP,
  SHIPPED,
  DELIVERED,
  COLLECTED,
  CANCELLED,
}

export type PreparationOrderStatusHistory = {
  _id: string;
  status: PreparationOrderStatus;
  statusDate: Date | string;
};

export type PreparationOrder = {
  _id: string;
  edb: EDB;
  chantier: Dockyard;
  code: PreparationOrderCode;
  company: {
    _id: string;
    name: string;
  };
  dockyard?: Dockyard;
  reference: string;
  refPreparationEntrepot: string;
  entrepot: Warehouse;
  products: Array<string | any>;
  status: PreparationOrderStatus;
  statusHistory: Array<PreparationOrderStatusHistory>;
  shipAdress: string;
  shipAdress2: string;
  shipCity: string;
  shipCountry: string;
  shipEntrepotName: string;
  shipPostalCode: string;
  shippingRecord?: ShippingRecord;
  shippingRecordId?: string;
  shipType: DispositionType | "";
  shipPlace: string;
  nearestShipWarehouse?: {
    name?: string;
    postalCode?: string;
    place?: string;
    city?: string;
    adress?: string;
  } | null;
  otherShipWarehouse?: {
    name?: string;
    postalCode?: string;
    place?: string;
    city?: string;
    adress?: string;
  } | null;
  subcontractorShipWarehouse?: {
    name?: string;
    postalCode?: string;
    place?: string;
    city?: string;
    adress?: string;
  } | null;
  colisage?: string;
  parcel?: Parcel;
  isDisable?: boolean;
};
